import { mapActions, mapGetters } from 'vuex';

import {
  JOB_STATUSES,
  ACTIVE_JOBS,
  UNFINISHED_JOBS,
  PAST_JOBS,
} from '@/constants/job-statuses';
import { NEW_MATCH_STATUSES, MATCH_STATUS_LABELS } from '@/constants/match-statuses';
import { URGENCY_LABELS, DEFAULT_URGENCY } from '@/constants/urgencies';
import { REQUEST_LIFECYCLE } from '@/utils/request-lifecycle';
import addUTCTimeZoneDesignator from '@/utils/add-utc-time-zone-designator';

export default {
  REQUEST_LIFECYCLE,
  JOB_STATUSES,
  URGENCY_LABELS,
  DEFAULT_URGENCY,
  MATCH_STATUSES: NEW_MATCH_STATUSES,
  MATCH_STATUS_LABELS,
  computed: {
    ...mapGetters('entities', {
      workOrderEntities: 'workOrders',
      matchEntities: 'matches',
      userEntities: 'user',
    }),
    ...mapGetters('dashboard/workOrder', [
      'currentWorkOrderMeta',
      'currentRawWorkOrder',
    ]),
    workOrder () {
      const workOrder = this.workOrderEntities[this.jobId];

      return (
        workOrder && {
          ...workOrder,
          time_created: addUTCTimeZoneDesignator(workOrder.time_created),
          user: this.userEntities[workOrder.user],
          matches: workOrder.matches.map(id => this.matchEntities[id]),
          isOpen: workOrder.status === this.$options.JOB_STATUSES.open.name
               || workOrder.status === this.$options.JOB_STATUSES.matched.name,
          isInProgress: workOrder.status === this.$options.JOB_STATUSES.in_progress.name,
          isCompleted: workOrder.status === this.$options.JOB_STATUSES.completed.name,
          isExpired: workOrder.status === this.$options.JOB_STATUSES.expired.name,
          isCanceled: workOrder.status === this.$options.JOB_STATUSES.canceled.name,
          isCancelled: workOrder.status === this.$options.JOB_STATUSES.cancelled.name,
          isActive: ACTIVE_JOBS.statuses.some(status => workOrder.status === status),
          isUnfinished: UNFINISHED_JOBS.statuses.some(status => workOrder.status === status),
          isPast: PAST_JOBS.statuses.some(status => workOrder.status === status),
          statusName: this.$options.JOB_STATUSES[workOrder.status].displayName,
        }
      );
    },
    urgency () {
      switch (this.workOrder.urgency_id) {
        case 1:
        case 2:
        case 5:
          return this.$options.URGENCY_LABELS[1];
        case 3:
        case 4:
        case 6:
          return this.$options.URGENCY_LABELS[2];
        default:
          return this.$options.URGENCY_LABELS[this.$options.DEFAULT_URGENCY];
      }
    },
  },
  methods: {
    ...mapActions('dashboard/workOrder', [
      'fetchWorkOrder',
    ]),
  },
};
